import { useSelector } from 'react-redux'
import { renderValue } from '@utils/numberUtils'

/**
 * Mini header: per-game identity (icon + title + tagline from games.js `mini`)
 * on the left, balance on the right. Balance formatting reuses the app's
 * conventions/formatter — same source as the normal BalanceModule.
 */
const Header = ({ game }) => {
  const { icon, title, tagline } = game?.mini ?? {}
  const displayTitle = title || game?.gameName || 'Game'

  const { balance, displayCurrencyCode } = useSelector((state) => state.wallet)
  const { number, currency, currencyConfig } = useSelector((state) => state.conventions)

  const formattedBalance = renderValue({
    value: balance,
    conventions: { number, currency, currencyConfig },
    options: { precisionType: 'balance' },
  })

  return (
    <div className="standard-mini-header-outer-container">
      <div className="standard-mini-header-identity-container">
        {icon ? (
          <div className="standard-mini-header-icon-container">
            <img
              src={icon}
              alt=""
              className="standard-mini-header-icon"
              onError={(e) => {
                e.currentTarget.style.display = 'none'
              }}
            />
          </div>
        ) : null}
        <div className="standard-mini-header-text-container">
          <div className="standard-mini-header-title">{displayTitle}</div>
          {tagline ? <div className="standard-mini-header-tagline">{tagline}</div> : null}
        </div>
      </div>

      <div className="standard-mini-header-balance-container">
        <div className="standard-mini-header-balance-label">Balance</div>
        <div className="standard-mini-header-balance-value">
          {displayCurrencyCode} {formattedBalance}
        </div>
      </div>
    </div>
  )
}

export default Header
